export class State {
  tableData: any;
}
